import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";

export default function StepGuarantor() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'guarantor'; // Definir el stepKey para este componente


    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Nombre{isFieldRequired('guarantor.nombre', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.nombre" control={control} rules={getValidationRules('guarantor.nombre', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.guarantor?.nombre && <small className="p-error">{errors.guarantor.nombre.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label> Fecha de Nacimiento{isFieldRequired('guarantor.fechaNacimiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.fechaNacimiento" control={control} rules={getValidationRules('guarantor.fechaNacimiento', stepKey)} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} className="w-full" dateFormat="yy-mm-dd" showIcon />
                    )} />
                    {errors.guarantor?.fechaNacimiento && <small className="p-error">{errors.guarantor.fechaNacimiento.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>CURP{isFieldRequired('guarantor.curp', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.curp" control={control} rules={getValidationRules('guarantor.curp', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.guarantor?.curp && <small className="p-error">{errors.guarantor.curp.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className="field col-12">
                    <label>Dirección{isFieldRequired('guarantor.direccion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.direccion" control={control} rules={getValidationRules('guarantor.direccion', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.guarantor?.direccion && <small className="p-error">{errors.guarantor.direccion.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>RFC{isFieldRequired('guarantor.rfc', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.rfc" control={control} rules={getValidationRules('guarantor.rfc', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.guarantor?.rfc && <small className="p-error">{errors.guarantor.rfc.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label>Identificación{isFieldRequired('guarantor.identificacion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.identificacion" control={control} rules={getValidationRules('guarantor.identificacion', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.guarantor?.identificacion && <small className="p-error">{errors.guarantor.identificacion.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Clave de Elector{isFieldRequired('guarantor.claveElector', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.claveElector" control={control} rules={getValidationRules('guarantor.claveElector', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.guarantor?.claveElector && <small className="p-error">{errors.guarantor.claveElector.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Emisión{isFieldRequired('guarantor.emision', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.emision" control={control} rules={getValidationRules('guarantor.emision', stepKey)} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} className="w-full" dateFormat="yy-mm-dd" showIcon />
                    )} />
                    {errors.guarantor?.emision && <small className="p-error">{errors.guarantor.emision.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>Vigencia{isFieldRequired('guarantor.vigencia', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.vigencia" control={control} rules={getValidationRules('guarantor.vigencia', stepKey)} render={({ field }) => (
                        <Calendar
                            name={field.name}
                            value={field.value}
                            onChange={(e) => field.onChange(e.value)}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            style={{
                                borderRadius: '17px',
                                overflow: 'hidden',
                                padding: '0',
                                width: '300px',
                                // height: '47px',
                                '& input': {
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0px',
                                }
                            }} panelStyle={{
                                borderRadius: '17px'
                            }} className="w-full" dateFormat="yy-mm-dd" showIcon />
                    )} />
                    {errors.guarantor?.vigencia && <small className="p-error">{errors.guarantor.vigencia.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label>NSS{isFieldRequired('guarantor.nss', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="guarantor.nss" control={control} rules={getValidationRules('guarantor.nss', stepKey)} render={({ field }) => (
                        <InputText {...field} className="w-full" />
                    )} />
                    {errors.guarantor?.nss && <small className="p-error">{errors.guarantor.nss.message}</small>}
                </div>
            </div>
        </div>
    );
}


